import React, { useContext } from 'react';

import createApp from '@shopify/app-bridge';
import { Redirect } from '@shopify/app-bridge/actions';
import { Fullscreen, History } from '@shopify/app-bridge/actions';
import { Frame, Loading, Spinner, BlockStack } from '@shopify/polaris';
import { PropsI } from '../../../Core/@types';
import { DIProps, extractUSername, parseJwt } from '../../../Core';
import { StoreDispatcher } from '../../..';
import { PanelProps } from '../Panel';
import { ContextualSaveBar } from '@shopify/app-bridge/actions';
import { getSessionToken } from '@shopify/app-bridge-utils';

export { ShowLogOutScreen } from './LogoutScreen';

// default if env don't have one
const env_API_KEY = '91f86057fadf7597521eda72f7aefd75';

// used to add hour in current time, used in getClientExpTime()
const env_exp_hours = 3;

// used for ROUTING
let env_user_id = '';

export function checkForAutoLogin(props: PanelProps) {
    const params: any = new URLSearchParams(props.location.search);
    if (params.get('user_token') !== null) {
        return true;
    }
    return false;
}

// Self explanatory
export function checkForOnboarding(props: PanelProps) {
    let amazon = [];
    if (props.redux?.account?.target?.amazon) {
        amazon = props.redux?.account?.target?.amazon;
    }
    if (Object.keys(amazon).length > 0) {
        if (process.env.REACT_APP_PROD === "1") {
            if (
                props.di.globalState.get(`onboarding`) === 'completed' &&
                Object.keys(amazon).length > 0
            ) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
    return true;
}

// if the Token is present save it to localstorage and open the app
export function redirectToApp(props: PanelProps) {
    const params: any = new URLSearchParams(props.location.search);
    const token = params.get('user_token');
    const user_id = params.get('user_id') ?? null;
    const shop = params.get('shop');
    const host = params.get('shopify_host');
    const username = params.get('username') ?? 'User';
    const onboarding = params.get('onboarding');

    //TODO: check if user token is expire

    if (user_id) {
        props.di.globalState.set(`${user_id}_user_authenticated`, `true`, true);
        props.di.globalState.set(`${user_id}_auth_token`, token, true);
        props.di.globalState.set(
            `${user_id}_username`,
            extractUSername(username),
            true
        );
        props.di.globalState.set(`${user_id}_shop`, shop, true);
        props.di.globalState.set(`${user_id}_host`, host, true);
    } else {
        props.di.globalState.set(`user_authenticated`, `true`);
        props.di.globalState.set(`auth_token`, token);
        props.di.globalState.set(`username`, extractUSername(username));
        props.di.globalState.set(`shop`, shop);
        props.di.globalState.set(`host`, host);
    }

    saveTheShopData(props);
    props.loginStatus();
    if (user_id) {
        props.history('/panel/' + user_id + '/' + props.match['*']);
    } else {
        props.history('./' + props.match['*']);
    }
}

// redirect to HOME server ( Back-end ) or Check if token is valid
export function RedirectToHome(props: PanelProps) {
    const params: any = new URLSearchParams(props.location.search);

    const dispatcher = useContext(StoreDispatcher);
    if (params.get('hmac') !== null && params.get('shop') !== null) {
        let url: any =
            props.di.environment.API_ENDPOINT +
            'connector/request/shopifyCurrentRoute?';
        let queryParams = '';
        let end = '';
        for (const param of params) {
            queryParams += end + param[0] + '=' + param[1];
            end = '&';
        }
        url += queryParams + end + 'current_route=' + (props.match['*'] ?? "home");
        props.di.globalState.set('queryParams', queryParams, true);

        if (params.get('host')) {
            // if token is valid, open the app, else redirect to Server
            if (
                getSaveShopData(props, params.get('shop'), params.get('host'))
            ) {
                props.loginStatus();
                dispatcher({
                    type: 'user_id',
                    state: {
                        user_id: env_user_id,
                    },
                });
                const params: any = new URLSearchParams(props.location.search);

                const success = params.get('success');
                const message = params.get('message');
                if (success && message) {
                    props.history(
                        '/panel/' +
                        env_user_id +
                        '/' +
                        (props.match['*'] ?? "home") +
                        '?success=' +
                        success +
                        '&message=' +
                        message
                    );
                } else {
                    props.history(
                        '/panel/' + env_user_id + '/' + (props.match['*'] ?? "home")
                    );
                }
            } else {

                // redirect to server
                // https://shopify.dev/apps/tools/app-bridge/actions/navigation/redirect
                appBridgeRedirect(url, props, params.get('host'));
            }
        } else {
            window.location.replace(url);
        }
    }
    else {
        // window.location.replace('https://admin.shopify.com');
        window.location.replace('https://admin.shopify.com/apps'
            + process.env.REACT_APP_SHOPIFY_APP_BASE
            + props.location.pathname);
    }
}

// if app us open OUTSIDE the shopify, redirect it to the Shopify Embedded page
export async function openAppInEmbedded(props: PropsI) {
    const { location } = props;
    let params: any = new URLSearchParams(location.search);

    const apiKey = process.env.REACT_APP_API_KEY ?? env_API_KEY;
    const host = props.di.globalState.get(`host`);
    const shop = props.di.globalState.get(`shop`);
    const user_token = props.di.globalState.get(`auth_token`);
    const username = props.di.globalState.get(`username`);
    const app = createApp({
        apiKey: apiKey,
        host: params.get('shopify_host') ?? params.get('host') ?? host,
    });
    // let url =
    //     'https://' +
    //     shop +
    //     '/admin/apps' +
    //     process.env.REACT_APP_SHOPIFY_APP_BASE +
    //     process.env.REACT_APP_SHOPIFY_ROUTE +
    //     props.match['*'] +
    //     '?shop=' +
    //     shop +
    //     '&shopify_host=' +
    //     host +
    //     '&username=' +
    //     username +
    //     '&user_id=' +
    //     props.di.user_id +
    //     '&user_token=' +
    //     user_token;

    // Fetch the session token to ensure Shopify recognizes session token usage
    try {
        const token = await getSessionToken(app);
        console.log("Shopify Session Token:", token);
    } catch (error) {
        console.error("Failed to get session token", error);
    }

    Redirect.create(app).dispatch(Redirect.Action.APP,
        process.env.REACT_APP_SHOPIFY_ROUTE + (props.match['*'] ?? "home"));
    // window.location.assign(url);
}

// use to open external URL
export function appBridgeRedirect(
    permissionUrl: string,
    props: any,
    host?: string | undefined | null
) {
    const apiKey = process.env.REACT_APP_API_KEY ?? env_API_KEY;
    if (!host) {
        host = props.di.globalState.get(`host`);
    }
    if (window.top == window.self || !host) {
        window.location.assign(permissionUrl);
    } else {
        const app = createApp({
            apiKey: apiKey,
            host: host,
        });
        Redirect.create(app).dispatch(Redirect.Action.REMOTE, permissionUrl);
    }
}

// use to open external URL
export function appBridgeRouting(permissionUrl: string, props: any) {
    const apiKey = process.env.REACT_APP_API_KEY ?? env_API_KEY;
    const host = props.di.globalState.get(`host`);
    if (window.top == window.self || !host) {
        props.history('../' + permissionUrl);
    } else {
        const app = createApp({
            apiKey: apiKey,
            host: host,
        });
        Redirect.create(app).dispatch(
            Redirect.Action.APP,
            process.env.REACT_APP_SHOPIFY_ROUTE + permissionUrl
        );
    }
}

// Save the current user data to the localstorage
function saveTheShopData(props: PropsI) {
    const params: any = new URLSearchParams(props.location.search);
    const token = params.get('user_token');
    const shop = params.get('shop');
    const host = params.get('shopify_host') ?? params.get('host');
    const username = params.get('username') ?? 'User';
    const tokenDecoded = parseJwt(token);
    const onboarding = params.get('onboarding');

    let shopData = JSON.parse(
        props.di.globalState.get(`all_shops`, true) ?? '{}'
    );

    shopData[shop] = {
        host: host,
        token: token,
        username: username,
        user_id: tokenDecoded['user_id'],
    };

    if (onboarding) {
        shopData[shop]['onboarding'] = true;
    } else {
        shopData[shop]['onboarding'] = false;
    }
    props.di.globalState.set(`all_shops`, JSON.stringify(shopData), true);
}

function getSaveShopData(props: PropsI, shop: string, host: string) {
    let shopData: any = JSON.parse(
        props.di.globalState.get(`all_shops`, true) ?? '{}'
    );

    if (shopData[shop]) {
        const tokenDecoded = parseJwt(shopData[shop]['token']);

        // check if it time to genarate new token, or use previous one
        if (getClientExpTime(tokenDecoded['exp'])) {
            // set the new HOST
            props.di.globalState.set(`${shopData['user_id']}_host`, host);
            shopData[shop]['host'] = host;

            // used for ROUTING
            env_user_id = shopData[shop]['user_id'];

            // new data updated
            props.di.globalState.set(
                `all_shops`,
                JSON.stringify(shopData),
                true
            );
            return true;
        }
    }
    return false;
}

export function getClientExpTime(exp: any, exp_hours?: number | null) {
    // exp time of token, will be genrated with 4 hr of expiration time
    let expiryDate: any = new Date(exp * 1000);

    // current plus +3hr
    let currentTime: any = new Date();
    currentTime = currentTime.addHours(exp_hours ?? env_exp_hours);

    // if current time exceed the exp time, it time to genarate new token
    if (expiryDate < currentTime) {
        return false;
    }

    return true;
}

export function callFullScreen(props: any) {
    const apiKey = process.env.REACT_APP_API_KEY ?? env_API_KEY;
    const host = props.di.globalState.get(`host`);
    const app = createApp({
        apiKey: apiKey,
        host: host,
    });
    const history = History.create(app);
    history.dispatch(
        History.Action.PUSH,
        '/apps/amazon-multi/panel/loading/template/62d562642ef55a061037d6e7'
    );
    // const fullscreen = Fullscreen.create(app);
    // fullscreen.dispatch(Fullscreen.Action.ENTER);
}

export function exitFullScreen(props: any) {
    const apiKey = process.env.REACT_APP_API_KEY ?? env_API_KEY;
    const host = props.di.globalState.get(`host`);
    const app = createApp({
        apiKey: apiKey,
        host: host,
    });
    const fullscreen = Fullscreen.create(app);
    fullscreen.dispatch(Fullscreen.Action.EXIT);
}

export function RenderSkeleton(props: PropsI) {
    return (
        <div className='custom-loading-app'>
            <Frame>
                {' '}
                <Loading />
                <BlockStack align='center' inlineAlign='center'>
                    <Spinner accessibilityLabel="Spinner example" size="large" />
                </BlockStack>
            </Frame>
        </div>
    );
}

export default function useContextualSaveBar(props: any) {
    const apiKey: any = process.env.REACT_APP_API_KEY ?? env_API_KEY;
    const host = props.di.globalState.get(`host`);
    let app: any = {};
    if (host) {
        app = createApp({
            apiKey: apiKey,
            host: host,
        });
    }
    function showSaveBar(
        discardfunc?: any,
        savefunc?: any,
        savebar_options?: any,
        sectionName?: string
    ) {
        let { loading, closeSaveBar, attributesLoader, disable_discard } = savebar_options;
        const options = {
            saveAction: {
                disabled: attributesLoader ?? false,
                loading: loading ?? false,
                content: 'Save'
            },
            discardAction: {
                disabled: loading ?? disable_discard ?? false,
                loading: false,
                discardConfirmationModal: closeSaveBar ?? true,
            },
        };
        const contextualSaveBar = ContextualSaveBar.create(app, options);
        contextualSaveBar.subscribe(
            //Subscribe actions on Discard button
            ContextualSaveBar.Action.DISCARD,
            function () {
                if (attributesLoader) {
                    props.error('Kindly wait, some sections are loading!');
                } else {
                    discardfunc();
                    contextualSaveBar.dispatch(ContextualSaveBar.Action.HIDE);
                }
            }
        );
        contextualSaveBar.subscribe(
            //Subscribe actons on Save button
            ContextualSaveBar.Action.SAVE,
            async function () {
                contextualSaveBar.set({ saveAction: { loading: true } });
                await savefunc();
                !savebar_options?.['hasError'] &&
                    contextualSaveBar.dispatch(ContextualSaveBar.Action.HIDE);
            }
        );
        contextualSaveBar.dispatch(ContextualSaveBar.Action.SHOW);
    }

    function hideSaveBar() {
        const options = {
            saveAction: {
                disabled: false,
                loading: false,
            },
            discardAction: {
                disabled: false,
                loading: false,
                discardConfirmationModal: true,
            },
        };
        const contextualSaveBar = ContextualSaveBar.create(app, options);
        contextualSaveBar.dispatch(ContextualSaveBar.Action.HIDE);
    }
    return { showSaveBar, hideSaveBar };
}

export function isAdminLoggedIn() {
    try {
        return sessionStorage.getItem('admin_login') != null;
    } catch (error) {
        return false;
    }
}

let dataFetch = 'no';
let dataFetchValue = false;
export function showOnlyGrid(user_id: string, props: DIProps) {

    let url = 'frontend/adminpanelamazonmulti/showOnlyGrid';

    if (dataFetch == 'yes') {
        return dataFetchValue;
    }

    if (isAdminLoggedIn()) {
        props.di.GET(url, { user_id: user_id }).then((e) => {
            dataFetch = 'yes';
            if (e.success) {
                dataFetchValue = true;
                return true;
            }
            dataFetchValue = false;
        });
    }
    return false;
}
